import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { ErrorBoundary } from '@components/shared/ErrorBoundary';
import { useNotificationsSSE } from '@hooks/useNotifications';

/**
 * AppLayout - Main authenticated layout wrapper
 *
 * Unified layout for all authenticated users:
 * - Sidebar on the left with navigation links
 * - Main content area rendering child routes via Outlet
 */
export function AppLayout() {
  // Establish persistent SSE connection for real-time notifications
  const notificationStatus = useNotificationsSSE();

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--base-surface-1,#141414)]">
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      {/* Sidebar - Always visible for authenticated users */}
      <Sidebar notificationStatus={notificationStatus} />

      {/* Page content */}
      <main
        id="main-content"
        className="flex-1 overflow-y-auto bg-[var(--base-surface-1,#141414)]"
      >
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
